<template>
    <div class="pagination-container d-flex flex-row justify-content-between flex-wrap">
      <!-- PAGINATION -->
      <ul class="d-flex pagination align-self-center mb-0">
        <li class="page-item page-item-previous" :class="{ 'disabled': !clickedPageValid(pageNum - 1) }" @click="pageClickedHandler(pageNum - 1)">
          <i class="page-link material-icons">keyboard_arrow_left</i>
          <button class="page-link prev-button">{{ $t('message.pagination.previousPage') }}</button>
        </li>
        <li class="page-item"
            v-for="(page, i) in getPagesRange(pageNum, getPageCount)"
            :key="i"
            :class="{ 'active': page === pageNum}"
            @click="pageClickedHandler(page)">
          <button class="page-link page-button">{{ page }}</button>
        </li>
        <li class="page-item page-item-next" :class="{ 'disabled': !clickedPageValid(pageNum + 1) }" @click="pageClickedHandler(pageNum + 1)">
          <button class="page-link next-button">{{ $t('message.pagination.nextPage') }}</button>
          <i class="page-link material-icons">keyboard_arrow_right</i>
        </li>
      </ul>
    </div>
  </template>
  
  <script>
  export default {
    name: 'pagination',
    components: {},
    props: {
      itemsCount: {
        type: Number,
        default: () => 0,
      },
      itemsPerPage: {
        type: Number,
        default: () => 0,
      },
      getPage: {
        type: Number,
        default: () => 1,
      },
      getPageCount: {
        type: Number,
        default: () => 1,
      },
    },
    data() {
      return {
        pagesDisplayed: [],
        pageNum: this.getPage,
        defaultItemsPerPageOptions: this.$env.routing.pagination.defaultItemsPerPageOptions,
      };
    },
    computed: {},
    methods: {
      /**
       * @description Determines displayed pagenumbers and delimiters in the pagination.
       * @param currentPage {number} The currently active page.
       * @param lastPage {number} The number of the last page (also the pageCount).
       * @returns {array}
       */
      getPagesRange(currentPage, lastPage) {
        const displayCount = Math.min(7, this.getPageCount);
        const displayStart = Math.max(1, Math.min(lastPage - displayCount + 1, currentPage - Math.round(displayCount / 2) + 1))
        return [...Array(displayCount).keys()].map(i =>  displayStart + i);
      },
      pageClickedHandler(page) {
        if (this.clickedPageValid(page)) this.changePageTo(page, this.itemsPerPage);
      },
      clickedPageValid(page) {
        return typeof page === 'number' && page > 0 && page <= this.getPageCount;
      },
      changePageTo(page) {
        this.pageNum = page;
        this.$emit('changePageTo', page);
        this.scrollTo(0, 0);
      },
      scrollTo(x, y) {
        window.scrollTo(x, y);
      },
    },
    created() {},
  };
  </script>
  
  <style lang="scss" scoped>
  .page-item {
    display: flex;
  
    &.disabled {
      color: rgba(0,0,0,0.7);
    }
  
    .page-link {
      line-height: normal;
    }
  }
  </style>
  